// Slider

/* eslint-disable no-nested-ternary */
/* eslint-disable no-invalid-this */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-params */
/* eslint-disable function-name-case */

/* global jQuery */

( function( $ ) {
    $(function() {
        // (Optional) Active an item if it has the class "is-active"	
        $('.c-accordion > .c-accordion-item.is-active').children('.c-accordion-panel').slideDown();
        
        $('.c-accordion > .c-accordion-item').click(function() {
            // Cancel the siblings
            $(this).siblings('.c-accordion-item').removeClass('is-active').children('.c-accordion-panel').slideUp();
            // Toggle the item
            $(this).toggleClass('is-active').children('.c-accordion-panel').slideToggle('ease-out');
        });
    });
}( jQuery ) );



// WEBPACK FOOTER //
// ./src/js/inc/accordion.js